import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import SummarizeIcon from "@mui/icons-material/Summarize";
import { isEmpty } from "lodash";
import { Button } from "src/components/MuiGenerals";
import { Params } from "src/features/common/types/GridRenderCellParams";
import { routeList } from "src/hooks/useRoutePermission";
import { SearchIcon } from "../../SweepRequestList";
import { GetListRes } from "../types/GetListRes";

type Link =
  | "operationRecords"
  | "operationTransactionRecords"
  | "tronRentResourceRecords";

const useOpenLinkCell = () => {
  const L = routeList;
  const renderOpenLinkCell = (link: Link) => (params: Params<GetListRes>) => {
    const batchId = params?.row?.rawData.batch_id ?? "";
    const chainType = params?.row?.rawData?.chain_type;
    const chainId = params?.row?.rawData?.chain_id;
    const smartAccountType = params?.row?.rawData?.batch.smart_account_type;

    const getLink = () => {
      switch (link) {
        case "operationRecords":
          return L.operationRecords[1];
        case "operationTransactionRecords":
          return L.operationTransactionRecords[1];
        case "tronRentResourceRecords":
          return L.tronRentResourceRecords[1];
      }
    };

    const getIcon = () => {
      switch (link) {
        case "operationRecords":
          return <SummarizeIcon />;
        case "operationTransactionRecords":
          return <AttachMoneyIcon />;
        case "tronRentResourceRecords":
          return <SearchIcon />;
      }
    };

    const getDisable = () => {
      if (isEmpty(batchId)) {
        return true;
      }
      
      if (
        link === "tronRentResourceRecords" &&
        (!smartAccountType || (chainType !== "3" &&
          chainId !== "1"))
      ) {
        return true;
      }
    };

    return (
      <Button
        disabled={getDisable()}
        onClick={() => window.open(`/${getLink()}?batchId=${batchId}`)}
        color="secondary"
        variant="contained">
        {getIcon()}
      </Button>
    );
  };

  return {
    renderOpenLinkCell,
  };
};
export default useOpenLinkCell;
